export class ImageBuilder {

    options: any = {
        maxwidth: 3200,
        maxheight:3200
    }
    constructor(private url: string) {

    }

    crop(crop_info: IEventResultImagecropinfo) {
        if (crop_info) {
            this.options['crop'] = `(${crop_info.x1},${crop_info.y1},${crop_info.x2},${crop_info.y2})`;
        }
        return this;
    }   

    setOptions(options) {
        this.options = { ...this.options, ...options };
        return this;
    }

    build() {
        if (!this.url) {
            return '#';
        }
        var param = $.param(this.options);
        if (this.url.indexOf('?') > -1) {
            return this.url + "&" + param;
        }
        return this.url + "?" + param;
    }
    maxWidth(maxWidth) {
        this.options['maxwidth'] = maxWidth;
        return this;
    }
    width(width){
        this.options['width']=width;
        return this;
    }
    tn(){        
        return this.width(300);
    }
    static src(url) {
        return new ImageBuilder(url);
    }
}


// WEBPACK FOOTER //
// ./src/components/Image/ImageBuilder.ts